export { default } from './StickerGroup.container'
